import { useEffect, useState } from "react";
import { ApiBaseResponse } from "hooks/axios/interfaces";
import { useRequest } from "hooks/axios/useRequest";

interface ApiGetResponse<T> extends ApiBaseResponse {
  data: T | undefined;
  refetch: () => Promise<T | undefined>;
}

export function useGet<ResponseType, ParamsType = undefined>(
  url: string,
  params?: ParamsType
): ApiGetResponse<ResponseType> {
  const [data, setData] = useState<ResponseType>();

  const { loading, error, requestCallback } = useRequest<
    ResponseType,
    ParamsType
  >("GET", url, params);

  useEffect(() => {
    requestCallback().then(
      response => setData(response),
      _rejects => setData(undefined)
    );
  }, [requestCallback]);

  return { data, loading, error, refetch: requestCallback };
}
